import trapFocus from './trap-focus';
import accessibleError from './accessible-error';
import autoFocus from './auto-focus';

export default {
  trapFocus,
  accessibleError,
  autoFocus,
};
